import { NavLink, useLocation } from "react-router";
import { getCurrentApp } from "@/lib/appNavigation";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `app-nav__link nav-link d-inline-flex align-items-center gap-2 fs-6 rounded-3 px-3 py-2 lh-sm ${
    isActive ? "active fw-semibold" : ""
  }`;

const AppNavItems = () => {
  const { pathname } = useLocation();
  const currentApp = getCurrentApp(pathname);
  const items = currentApp.navItems ?? [];

  if (items.length === 0) {
    return null;
  }

  return (
    <ul className="nav app-nav gap-1 flex-row flex-wrap align-items-center mb-0">
      {items.map((item) => (
        <li className="nav-item" key={item.id}>
          <NavLink
            id={`app-nav-${item.id}`}
            to={item.to}
            end={item.end}
            className={navLinkClass}
          >
            {item.label}
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

export default AppNavItems;
